import type { Gender, Language } from 'config/enums';
import {
  TeamingReason,
  TeamingType,
} from 'features/teaming/teaming-base/enums';

/**
 * Helper function to construct teaming options.
 * Ensures `gender` is converted to a number.
 */
export const createTeamingOptions = (gender: Gender, language: Language) => ({
  gender: Number(gender),
  reason: TeamingReason.Handoff,
  language,
  teamingType: TeamingType.RemoteRq,
  isRemote: true,
});
